// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-85063012","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader?sourceMap!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/_Icons/Close.vue
// module id = 20
// module chunks = 0